import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.map";

var diff = function diff(obj1, obj2) {
  var toMutate = {};
  Array.from(new Set(Object.keys(obj1).concat(Object.keys(obj2)))).map(function (key) {
    if (obj1[key] !== obj2[key]) {
      toMutate[key] = obj2[key];
    }
  });
  return toMutate;
};

export default diff;